module.exports = __webpack_public_path__ + "img/shuttle_enabled.a51af96b.svg";